export const config = {
  eventGroup: 'mechabreak_fab_pc_20250321',
  name: '《解限机》公测FAB页-PC',
  identify: 'codebreak',
  eventTags: ['mechabreak', 'fab', 'pc']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的来源，首页、公测礼包
     */
    clickReservation: function(title) {
      report({
        eventName: 'click_reservation',
        eventDescription: '立即预约',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的来源，首页、公测礼包
     */
    clickVerify: function(title) {
      report({
        eventName: 'click_verify',
        eventDescription: '获取验证码',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的来源，首页、公测礼包
     */
    clickComfirmReserve: function(title) {
      report({
        eventName: 'click_comfirm_reserve',
        eventDescription: '确认预约',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的来源，首页、公测礼包
     */
    clickRegister: function(title) {
      report({
        eventName: 'click_register',
        eventDescription: '快速注册',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报所点击的分享渠道/复制链接
     */
    clickShare: function(title) {
      report({
        eventName: 'click_share',
        eventDescription: '分享',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },

    clickSteam: function() {
      report({
        eventName: 'click_steam',
        eventDescription: 'Steam'
      });
    },
    clickXbox: function() {
      report({
        eventName: 'click_xbox',
        eventDescription: 'Xbox'
      });
    },
    clickBuy: function() {
      report({
        eventName: 'click_buy',
        eventDescription: '礼包购买'
      });
    },

    clickDownload: function() {
      report({
        eventName: 'click_download',
        eventDescription: '下载'
      });
    },
    /**
     * @param {string} [title] - 上报点击的来源，首页、公测礼包
     */
    clickLogin: function(title) {
      report({
        eventName: 'click_login',
        eventDescription: '登录',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickCDK: function() {
      report({
        eventName: 'click_CDK',
        eventDescription: '公测礼包'
      });
    },
    clickCopyCDK: function() {
      report({
        eventName: 'click_copy_CDK',
        eventDescription: '复制CDK'
      });
    },
    clickSteamCDK: function() {
      report({
        eventName: 'click_steam_CDK',
        eventDescription: 'Steam礼包'
      });
    },
    clickCopySteam: function() {
      report({
        eventName: 'click_copy_steam',
        eventDescription: '复制Steam礼包'
      });
    },
    clickReceive: function() {
      report({
        eventName: 'click_receive',
        eventDescription: '领取公测礼包'
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
